import * as React from 'react';

const SvgArrowRedo = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "m15.03 12 2.52-3H10.5a4.5 4.5 0 0 0 0 9h.5v2h-.5a6.5 6.5 0 1 1 0-13h7.05l-2.52-3h2.61L21 8l-3.36 4h-2.61Z", clipRule: "evenodd" })
);

export { SvgArrowRedo as default };
//# sourceMappingURL=ArrowRedo.es.js.map
